import React from "react";
import { ErrorWrap } from "./styled";

const ForbiddenPage = () => {
  
  return (
    <ErrorWrap>
      <div>
        <h1>403 - Forbidden</h1>
        <p>You don&apos;t have permission to access this page.</p>
      </div>
    </ErrorWrap>
  );
};

export default ForbiddenPage;
